import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CONFI_COST_LOADING = 'GET_CONFI_COST_LOADING';
export const GET_CONFI_COST_SUCCESS = 'GET_CONFI_COST_SUCCESS';
export const GET_CONFI_COST_REJECT = 'GET_CONFI_COST_REJECT';

//* ACTIONS ------------------------------------------------
export const getConfiCostLoading = () => ({ type: GET_CONFI_COST_LOADING });
export const getConfiCostSuccess = (payload) => ({ type: GET_CONFI_COST_SUCCESS, payload });
export const getConfiCostReject = (payload) => ({ type: GET_CONFI_COST_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getConfiCostRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Costs/web/GetAllCosts`, options);
};

